<template>
    <span :class="'overview_graph_change ' + className()">
        {{
            validValue() ? ((diffPercent > 0 ? '+' : '') + diffPercent.toFixed(0) + ' %') : ''
        }}
    </span>
</template>

<script>
export default {
    name: 'overview-graph-change',
    props: ['diffPercent'],
    methods: {
        validValue: function () {
            return (typeof this.diffPercent === 'number' && Number.isFinite(this.diffPercent))
        },
        className: function () {
            if (this.validValue()) {
                return (this.diffPercent >= 0) ? 'positive' : 'negative'
            } else {
                return 'none'
            }
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/templates/part/ui/overview-graph-change.vue